
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.75 24C.785 24 0 23.215 0 22.25V4.75C0 3.785.785 3 1.75 3h2V1.75C3.75.785 4.535 0 5.5 0H8c.965 0 1.75.785 1.75 1.75V3h2c.88 0 1.611.653 1.732 1.5h8.268A2.252 2.252 0 0124 6.75v3.75a2.252 2.252 0 01-2.25 2.25A3.754 3.754 0 0018 16.5v3.75a2.252 2.252 0 01-2.25 2.25h-2.268A1.752 1.752 0 0111.75 24h-10zm10-1.5a.25.25 0 00.25-.25v-14H5.25V22.5h6.5zM1.5 22.25c0 .138.112.25.25.25h2V8.25H1.5v14zM15.75 21a.75.75 0 00.75-.75V16.5a5.256 5.256 0 015.25-5.25.75.75 0 00.75-.75V6.75a.75.75 0 00-.75-.75H13.5v15h2.25zM12 6.75v-2a.25.25 0 00-.25-.25h-10a.25.25 0 00-.25.25v2H12zM8.25 3V1.75A.25.25 0 008 1.5H5.5a.25.25 0 00-.25.25V3h3z"}}),_c('circle',{attrs:{"cx":"16.125","cy":"8.625","r":"1.125"}}),_c('circle',{attrs:{"cx":"19.875","cy":"8.625","r":"1.125"}})])
          )
        }
      }
    